import type { ReactElement } from 'react'

import type { TypeSocialShareWidgetEntry } from '@contentful-types/component-share-widget'

export function SocialShareWidget({ data }: { data: TypeSocialShareWidgetEntry }): ReactElement {
  console.info('SocialShareWidget props:', data)

  return <div>Placeholder for SocialShareWidget</div>
}
